/*
 * @Author: MWeiLiu
 * @Date: 2019-12-17 20:14:00
 * @Last Modified by: MWeiLiu
 * @Last Modified time: 2019-12-18 14:19:32
 */

const notFind = {
  path: '/404',
  name: 'notFind',
  value: '404'
}

const index = {
  path: '/index',
  name: 'index',
  value: '首页'
}

const information = {
  path: '/information',
  name: 'information',
  value: '藏品文库信息'
}

const informationcon = {
  path: '/information/details',
  name: 'informationcon',
  value: '藏品文库信息详情'
}

const inorganic = {
  path: '/inorganic',
  name: 'inorganic',
  value: '无机质藏品文库信息'
}

const boutique = {
  path: '/boutique',
  name: 'boutique',
  value: '数字精品'
}

const boutiquecon = {
  path: '/boutique/details',
  name: 'boutiquecon',
  value: '数字精品详情'
}

const boutiquecon1 = {
  path: '/boutique/details1',
  name: 'boutiquecon1',
  value: '数字精品详情'
}

const statistics = {
  path: '/statistics',
  name: 'statistics',
  value: '藏品统计'
}

const mindex = {
  path: '/m/index',
  name: 'mindex',
  value: 'h5首页'
}

const minformation = {
  path: '/m/information',
  name: 'minformation',
  value: 'h5藏品文库信息'
}

const minorganic = {
  path: '/m/inorganic',
  name: 'minorganic',
  value: 'h5无机质藏品文库信息'
}

const minformationcon = {
  path: '/m/information/details',
  name: 'minformationcon',
  value: 'h5藏品文库信息详情'
}

const mboutique = {
  path: '/m/boutique',
  name: 'mboutique',
  value: 'hs数字精品'
}

const mboutiquecon = {
  path: '/m/boutique/details',
  name: 'mboutiquecon',
  value: 'hs数字精品详情'
}

const mboutiquecon1 = {
  path: '/m/boutique/details1',
  name: 'mboutiquecon1',
  value: 'hs数字精品详情'
}

const mstatistics = {
  path: '/m/statistics',
  name: 'mstatistics',
  value: 'h5藏品统计'
}

export default {
  notFind,
  index,
  information,
  informationcon,
  inorganic,
  boutique,
  boutiquecon,
  statistics,
  mindex,
  minformation,
  minorganic,
  minformationcon,
  mboutique,
  mboutiquecon,
  mboutiquecon1,
  boutiquecon1,
  mstatistics
}



// WEBPACK FOOTER //
// ./src/router/mould.js